import React, { useState } from "react";
import axios from "axios";
import { Phone, ArrowRight, CheckCircle, Truck, Clock, DollarSign, Shield, ChevronDown } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const PHONE = "514-973-4754";
const HERO_IMG = "https://images.unsplash.com/photo-1645736315000-6f788915923b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxmb3JrbGlmdCUyMHdhcmVob3VzZXxlbnwwfHx8fDE3NzYxMzA4ODd8MA&ixlib=rb-4.1.0&q=85&w=1600";
const IMG_NEW = "https://images.pexels.com/photos/8760709/pexels-photo-8760709.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const IMG_USED = "https://images.pexels.com/photos/14688876/pexels-photo-14688876.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const t = {
  en: {
    lang_toggle: "FR",
    hero_overline: "QUEBEC'S FORKLIFT MARKETPLACE",
    hero_title: "Access Hundreds of Used and New Forklifts — Best Quality-Price Ratio in Quebec",
    hero_subtitle: "Access hundreds of forklifts — propane, diesel, electric — matched to your exact needs. No middleman, no markup.",
    hero_cta: "Get a Free Quote",
    hero_call: "Or call us now",
    trust_1: "Same-day matching",
    trust_2: "Best quality-price ratio",
    trust_3: "New & used inventory",
    trust_4: "Quebec-based service",
    section_title: "How It Works",
    step_1_title: "Tell us what you need",
    step_1_desc: "Leave your phone number or email with your forklift requirements — capacity, engine type, budget.",
    step_2_title: "We find your match",
    step_2_desc: "Our system cross-references your criteria against hundreds of available forklifts in real time.",
    step_3_title: "Get your quote",
    step_3_desc: "We contact you within hours with the best matching options at the best prices.",
    types_title: "New & Used Forklifts Available",
    type_new: "New Forklifts",
    type_new_desc: "Latest models from top brands. Full warranty. Financing available.",
    type_used: "Used Forklifts",
    type_used_desc: "Inspected, reliable units at a fraction of the price. Best value in Quebec.",
    specs: "Propane · Diesel · Electric · 2-Stage & 3-Stage Mast · Pneumatic & Cushion Tires · 2WD & 4WD",
    form_title: "Get Your Free Quote",
    form_subtitle: "Leave your info and we'll match you with the best forklift for your needs — fast.",
    form_name: "Your Name",
    form_contact: "Phone or Email",
    form_contact_placeholder: "514-555-1234 or your@email.com",
    form_needs: "What are you looking for?",
    form_needs_placeholder: "e.g., Used propane forklift, 5000 lbs, budget $20k...",
    form_submit: "Get My Free Quote",
    form_privacy: "We'll never share your info. Expect a response within hours.",
    success_title: "Request Received!",
    success_text: "We're matching your request right now. Expect a call or email within hours.",
    success_call: "Need it faster? Call us directly:",
    browse_title: "Browse Our Full Inventory",
    browse_desc: "See all available forklifts on our site with detailed specs and photos.",
    browse_cta: "View Full Inventory",
    footer_text: "Gestión Farcar — Fork Finder Quebec",
    footer_service: "Fast, practical forklift service.",
  },
  fr: {
    lang_toggle: "EN",
    hero_overline: "LE MARCHÉ DE CHARIOTS ÉLÉVATEURS DU QUÉBEC",
    hero_title: "Accédez à des centaines de chariots élévateurs usagés et neufs — Meilleur rapport qualité-prix au Québec",
    hero_subtitle: "Accédez à des centaines de chariots — propane, diesel, électrique — jumelés à vos besoins exacts. Pas d'intermédiaire, pas de surcharge.",
    hero_cta: "Obtenir une soumission gratuite",
    hero_call: "Ou appelez-nous maintenant",
    trust_1: "Jumelage le jour même",
    trust_2: "Meilleur rapport qualité-prix",
    trust_3: "Inventaire neuf et usagé",
    trust_4: "Service basé au Québec",
    section_title: "Comment ça fonctionne",
    step_1_title: "Dites-nous ce qu'il vous faut",
    step_1_desc: "Laissez votre numéro de téléphone ou courriel avec vos besoins — capacité, type de moteur, budget.",
    step_2_title: "On trouve votre match",
    step_2_desc: "Notre système croise vos critères avec des centaines de chariots disponibles en temps réel.",
    step_3_title: "Recevez votre soumission",
    step_3_desc: "On vous contacte dans les heures qui suivent avec les meilleures options aux meilleurs prix.",
    types_title: "Chariots neufs et usagés disponibles",
    type_new: "Chariots neufs",
    type_new_desc: "Derniers modèles des meilleures marques. Garantie complète. Financement disponible.",
    type_used: "Chariots usagés",
    type_used_desc: "Unités inspectées et fiables à une fraction du prix. Meilleure valeur au Québec.",
    specs: "Propane · Diesel · Électrique · Mât 2 et 3 stages · Pneus pneumatiques et coussin · 2RM et 4RM",
    form_title: "Obtenez votre soumission gratuite",
    form_subtitle: "Laissez vos infos et on vous jumelle avec le meilleur chariot pour vos besoins — rapidement.",
    form_name: "Votre nom",
    form_contact: "Téléphone ou courriel",
    form_contact_placeholder: "514-555-1234 ou votre@courriel.com",
    form_needs: "Que recherchez-vous?",
    form_needs_placeholder: "ex: Chariot propane usagé, 5000 lbs, budget 20k$...",
    form_submit: "Obtenir ma soumission gratuite",
    form_privacy: "Vos informations restent confidentielles. Réponse en quelques heures.",
    success_title: "Demande reçue!",
    success_text: "Nous cherchons le meilleur match pour vous maintenant. Attendez un appel ou courriel dans les prochaines heures.",
    success_call: "Besoin plus vite? Appelez-nous:",
    browse_title: "Parcourez notre inventaire complet",
    browse_desc: "Voyez tous les chariots disponibles avec specs détaillées et photos.",
    browse_cta: "Voir l'inventaire complet",
    footer_text: "Gestión Farcar — Fork Finder Québec",
    footer_service: "Service de chariots élévateurs rapide et pratique.",
  },
};

export default function LandingPageLP() {
  const [lang, setLang] = useState("fr");
  const T = t[lang];
  const [form, setForm] = useState({ name: "", contact: "", needs: "" });
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name) {
      toast.error(lang === "en" ? "Please fill in your name and contact info." : "Veuillez remplir votre nom et vos coordonnées.");
      return;
    }
    setSubmitting(true);
    try {
      const isEmail = form.contact.includes("@");
      const body = {
        name: form.name,
        email: isEmail ? form.contact : "lead@forkfinder.ca",
        phone: isEmail ? "" : form.contact,
        notes: `[LANDING PAGE LEAD] Contact: ${form.contact}. Looking for: ${form.needs}`,
      };
      await axios.post(`${API}/customer-requests`, body);
      setSuccess(true);
    } catch {
      toast.error(lang === "en" ? "Error submitting. Please try again or call us." : "Erreur. Veuillez réessayer ou nous appeler.");
    } finally {
      setSubmitting(false);
    }
  };

  const scrollToForm = () => {
    document.getElementById("lp-form")?.scrollIntoView({ behavior: "smooth" });
  };

  if (success) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center px-6">
        <div className="text-center max-w-md" data-testid="lp-success">
          <CheckCircle className="w-16 h-16 text-yellow-500 mx-auto mb-6" />
          <h1 className="font-heading text-3xl font-black text-gray-900 mb-3">{T.success_title}</h1>
          <p className="text-gray-700 mb-6">{T.success_text}</p>
          <p className="text-sm text-gray-500 mb-2">{T.success_call}</p>
          <a href={`tel:${PHONE.replace(/-/g, "")}`} className="inline-flex items-center gap-2 text-2xl font-heading font-black text-gray-900 hover:text-yellow-600 transition-colors">
            <Phone className="w-6 h-6" /> {PHONE}
          </a>
          <div className="mt-8">
            <a
              href="/inventory"
              className="inline-flex items-center gap-2 bg-yellow-400 text-gray-900 font-bold hover:bg-yellow-500 transition-colors px-6 py-3 rounded-sm"
            >
              {T.browse_cta} <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white" data-testid="landing-page-lp">
      {/* Sticky top bar */}
      <div className="fixed top-0 left-0 right-0 z-50 bg-gray-900 text-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 flex items-center justify-between h-12">
          <a href={`tel:${PHONE.replace(/-/g, "")}`} className="flex items-center gap-2 text-sm font-bold hover:text-yellow-400 transition-colors" data-testid="lp-phone-top">
            <Phone className="w-4 h-4" /> {PHONE}
          </a>
          <div className="flex items-center gap-4">
            <span className="text-xs text-gray-400 hidden sm:block font-heading">Fork Finder</span>
            <button
              data-testid="lp-lang-toggle"
              onClick={() => setLang(lang === "en" ? "fr" : "en")}
              className="text-xs font-bold tracking-widest uppercase px-2 py-0.5 border border-gray-600 rounded-sm hover:bg-gray-800 transition-colors"
            >
              {T.lang_toggle}
            </button>
          </div>
        </div>
      </div>

      {/* Hero */}
      <section className="relative pt-12" data-testid="lp-hero">
        <div className="absolute inset-0 z-0">
          <img src={HERO_IMG} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-b from-gray-900/85 via-gray-900/75 to-gray-900/90" />
        </div>
        <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 py-16 sm:py-24 text-center">
          <p className="text-xs tracking-[0.25em] uppercase font-bold text-yellow-400 mb-4">{T.hero_overline}</p>
          <h1 className="font-heading text-3xl sm:text-5xl lg:text-6xl font-black text-white leading-tight max-w-4xl mx-auto">
            {T.hero_title}
          </h1>
          <p className="mt-4 text-base sm:text-lg text-gray-300 max-w-2xl mx-auto leading-relaxed">
            {T.hero_subtitle}
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={scrollToForm}
              data-testid="lp-hero-cta"
              className="inline-flex items-center gap-2 bg-yellow-400 text-gray-900 font-bold hover:bg-yellow-500 transition-colors px-8 py-4 rounded-sm text-lg"
            >
              {T.hero_cta} <ArrowRight className="w-5 h-5" />
            </button>
            <a
              href={`tel:${PHONE.replace(/-/g, "")}`}
              className="inline-flex items-center gap-2 text-white font-medium hover:text-yellow-400 transition-colors text-sm"
            >
              <Phone className="w-4 h-4" /> {T.hero_call}: {PHONE}
            </a>
          </div>

          {/* Trust badges */}
          <div className="mt-12 grid grid-cols-2 sm:grid-cols-4 gap-4 max-w-3xl mx-auto">
            {[
              { icon: Clock, text: T.trust_1 },
              { icon: DollarSign, text: T.trust_2 },
              { icon: Truck, text: T.trust_3 },
              { icon: Shield, text: T.trust_4 },
            ].map((b, i) => (
              <div key={i} className="flex items-center gap-2 justify-center bg-white/10 backdrop-blur-sm rounded-sm px-3 py-2.5">
                <b.icon className="w-4 h-4 text-yellow-400 flex-shrink-0" />
                <span className="text-xs font-semibold text-white">{b.text}</span>
              </div>
            ))}
          </div>

          <div className="mt-10 animate-bounce">
            <ChevronDown className="w-6 h-6 text-gray-400 mx-auto" />
          </div>
        </div>
      </section>

      {/* How it works */}
      <section className="py-16 sm:py-20 bg-white" data-testid="lp-how-it-works">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <h2 className="font-heading text-2xl sm:text-3xl font-bold text-gray-900 text-center mb-12">{T.section_title}</h2>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
            {[
              { num: "1", title: T.step_1_title, desc: T.step_1_desc },
              { num: "2", title: T.step_2_title, desc: T.step_2_desc },
              { num: "3", title: T.step_3_title, desc: T.step_3_desc },
            ].map((step) => (
              <div key={step.num} className="text-center">
                <div className="w-12 h-12 bg-yellow-400 text-gray-900 font-heading font-black text-xl rounded-full flex items-center justify-center mx-auto mb-4">
                  {step.num}
                </div>
                <h3 className="font-heading text-lg font-semibold text-gray-900 mb-2">{step.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* New & Used */}
      <section className="py-16 sm:py-20 bg-gray-50" data-testid="lp-types">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <h2 className="font-heading text-2xl sm:text-3xl font-bold text-gray-900 text-center mb-10">{T.types_title}</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div className="bg-white border border-gray-200 rounded-sm overflow-hidden">
              <div className="aspect-[16/9] overflow-hidden">
                <img src={IMG_NEW} alt="" className="w-full h-full object-cover" />
              </div>
              <div className="p-6">
                <h3 className="font-heading text-xl font-bold text-gray-900 mb-2">{T.type_new}</h3>
                <p className="text-sm text-gray-600">{T.type_new_desc}</p>
              </div>
            </div>
            <div className="bg-white border border-gray-200 rounded-sm overflow-hidden">
              <div className="aspect-[16/9] overflow-hidden">
                <img src={IMG_USED} alt="" className="w-full h-full object-cover" />
              </div>
              <div className="p-6">
                <h3 className="font-heading text-xl font-bold text-gray-900 mb-2">{T.type_used}</h3>
                <p className="text-sm text-gray-600">{T.type_used_desc}</p>
              </div>
            </div>
          </div>
          <p className="text-center text-xs text-gray-500 mt-6 font-mono tracking-wide">{T.specs}</p>
        </div>
      </section>

      {/* Lead Form */}
      <section id="lp-form" className="py-16 sm:py-20 bg-gray-900" data-testid="lp-form-section">
        <div className="max-w-xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-8">
            <h2 className="font-heading text-2xl sm:text-3xl font-bold text-white mb-2">{T.form_title}</h2>
            <p className="text-sm text-gray-400">{T.form_subtitle}</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4" data-testid="lp-lead-form">
            <div>
              <label className="text-sm font-semibold text-gray-300 mb-1 block">{T.form_name}</label>
              <input
                data-testid="lp-input-name"
                type="text"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                className="w-full bg-gray-800 border border-gray-700 text-white rounded-sm px-4 py-3 focus:ring-2 focus:ring-yellow-400 focus:border-yellow-400 placeholder-gray-500"
              />
            </div>
            <div>
              <label className="text-sm font-semibold text-gray-300 mb-1 block">{T.form_contact}</label>
              <input
                data-testid="lp-input-contact"
                type="text"
                value={form.contact}
                onChange={(e) => setForm({ ...form, contact: e.target.value })}
                placeholder={T.form_contact_placeholder}
                className="w-full bg-gray-800 border border-gray-700 text-white rounded-sm px-4 py-3 focus:ring-2 focus:ring-yellow-400 focus:border-yellow-400 placeholder-gray-500"
              />
            </div>
            <div>
              <label className="text-sm font-semibold text-gray-300 mb-1 block">{T.form_needs}</label>
              <textarea
                data-testid="lp-input-needs"
                value={form.needs}
                onChange={(e) => setForm({ ...form, needs: e.target.value })}
                placeholder={T.form_needs_placeholder}
                rows={3}
                className="w-full bg-gray-800 border border-gray-700 text-white rounded-sm px-4 py-3 focus:ring-2 focus:ring-yellow-400 focus:border-yellow-400 placeholder-gray-500 resize-none"
              />
            </div>
            <button
              type="submit"
              disabled={submitting}
              data-testid="lp-submit-btn"
              className="w-full bg-yellow-400 text-gray-900 font-bold hover:bg-yellow-500 transition-colors px-6 py-4 rounded-sm text-lg disabled:opacity-50"
            >
              {submitting ? "..." : T.form_submit}
            </button>
            <p className="text-xs text-gray-500 text-center">{T.form_privacy}</p>
          </form>

          <div className="mt-8 text-center">
            <p className="text-sm text-gray-400 mb-2">{T.hero_call}</p>
            <a href={`tel:${PHONE.replace(/-/g, "")}`} className="inline-flex items-center gap-2 text-2xl font-heading font-black text-yellow-400 hover:text-yellow-300 transition-colors">
              <Phone className="w-6 h-6" /> {PHONE}
            </a>
          </div>
        </div>
      </section>

      {/* Browse Inventory CTA */}
      <section className="py-12 bg-white border-t border-gray-200" data-testid="lp-browse">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 text-center">
          <h3 className="font-heading text-xl font-bold text-gray-900 mb-2">{T.browse_title}</h3>
          <p className="text-sm text-gray-600 mb-4">{T.browse_desc}</p>
          <a
            href="/inventory"
            data-testid="lp-browse-cta"
            className="inline-flex items-center gap-2 bg-gray-100 text-gray-900 font-medium hover:bg-gray-200 transition-colors px-6 py-3 rounded-sm border border-gray-200"
          >
            {T.browse_cta} <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-6 bg-gray-900 border-t border-gray-800">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gray-500">{T.footer_text}</p>
          <p className="text-xs text-gray-600">{T.footer_service}</p>
          <a href={`tel:${PHONE.replace(/-/g, "")}`} className="text-xs text-gray-400 hover:text-yellow-400 flex items-center gap-1">
            <Phone className="w-3 h-3" /> {PHONE}
          </a>
        </div>
      </footer>
    </div>
  );
}
